import React from "react";
import FormItem from "../../../molecules/FormItem/FormItem";
import { Form, Formik } from "formik";
import { initialValues } from "./initialValues";
import { countries } from "../../../../vars/countries";
import {
  areas,
  customers,
  specialisations,
  types,
  willStocks,
} from "./selects";
import { validationSchema } from "./validationSchema";
import styled from "styled-components";
import { PRIMARY } from "../../../../vars/vars";
import Checkbox from "../../../atoms/Checkbox/Checkbox";
import { Link } from "react-router-dom";
import UniversalModal from "../../UniversalModal/UniversalModal";
import ReCAPTCHA from "react-google-recaptcha";
import useContactForm from "../../../../hooks/useContactForm";

const DistributorForm = () => {
  const recaptchaDealerRef = React.useRef(null);

  const { onSubmit, showModal, modalText, setShowModal } = useContactForm(
    "DEALER",
    recaptchaDealerRef
  );

  const props = {
    onSubmit,
    initialValues,
    validationSchema,
  };
  return (
    <section>
      <Formik {...props}>
        {(props) => (
          <Form>
            <FormItem label={"First name"} required name={"firstName"} />
            <FormItem label={"Last name"} required name={"lastName"} />
            <FormItem label={"Name of the company"} required name={"company"} />
            <FormItem label={"Email"} required name={"email"} type={"email"} />
            <FormItem label={"Phone"} name={"phone"} type={"phone"} />
            <FormItem label={"EU VAT number"} required name={"vat"} />
            <Interlude>Billing Address</Interlude>
            <FormItem
              label={"Street address and number"}
              required
              name={"billingAddress1"}
            />
            <FormItem
              label={"Apartment, suite, etc. (optional)"}
              name={"billingAddress2"}
            />
            <FormItem label={"City"} required name={"billingAddressCity"} />
            <FormItem
              label={"Postal code"}
              required
              name={"billingAddressZip"}
            />
            <FormItem
              required
              selectLabel={"Country"}
              name={"billingAddressCountry"}
              label={"Country"}
              select
              items={countries}
            />
            <div className={"mt-2"}>
              <Checkbox name={"isDeliveryDifferent"}>
                Delivery address different than billing
              </Checkbox>
            </div>
            {props.values.isDeliveryDifferent && (
              <>
                <Interlude>Billing Address</Interlude>
                <FormItem
                  label={"Street address and number"}
                  required
                  name={"deliveryAddress1"}
                />
                <FormItem
                  label={"Apartment, suite, etc. (optional)"}
                  name={"deliveryAddress2"}
                />
                <FormItem
                  label={"City"}
                  required
                  name={"deliveryAddressCity"}
                />
                <FormItem
                  label={"Postal code"}
                  required
                  name={"deliveryAddressZip"}
                />
                <FormItem
                  required
                  selectLabel={"Country"}
                  name={"deliveryAddressCountry"}
                  label={"Country"}
                  select
                  items={countries}
                />
              </>
            )}
            <FormItem label={"Message"} textarea required name={"message"} />
            <Interlude>
              By answering following voluntary questions you can help us deliver
              a tailor-made service to you:
            </Interlude>
            <FormItem
              select
              label={
                "Are you a wholesaler / retailer / specialised garage or other?"
              }
              name={"type"}
              items={types}
            />
            <FormItem
              select
              label={
                "Are your customers individual car owners or garages and retail outlets?"
              }
              name={"customer"}
              items={customers}
            />
            <FormItem
              label={"Do you have an online shop (if such - what is the www)?"}
              name={"www"}
            />
            <FormItem
              select
              label={
                "Are your customers individual car owners or garages and retail outlets?"
              }
              name={"specialisation"}
              items={specialisations}
            />
            <FormItem label={"Specify"} name={"specialisationOther"} />
            <FormItem
              select
              label={
                "Do you service local area/entire country/sell outside of country?"
              }
              name={"area"}
              items={areas}
            />
            <FormItem
              select
              label={"Do you plan to stock products in your warehouse?"}
              name={"willStock"}
              items={willStocks}
            />
            <Checkbox name={"privacyDealer"}>
              I agree with{" "}
              <StyledLink to={"/privacy"}>Privacy Policy</StyledLink>
            </Checkbox>
            {showModal && (
              <UniversalModal
                text={modalText}
                clickHandler={() => setShowModal(false)}
              />
            )}
            <ReCAPTCHA
              ref={recaptchaDealerRef}
              size="invisible"
              sitekey="6LenKrEUAAAAAE1bjyJeZ563lCnEG29Y0sEyBhp3"
            />
            <StyledButton type={"submit"}>Submit</StyledButton>
          </Form>
        )}
      </Formik>
    </section>
  );
};

export default DistributorForm;

const Interlude = styled.p`
  margin-top: 20px;
`;

const StyledButton = styled.button`
  margin: 20px 0;
  display: block;
  padding: 10px 20px;
  background: #292b29;
  border: none;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.1s ease;
  white-space: nowrap;

  &:hover {
    background-color: ${PRIMARY};
  }
`;

const StyledLink = styled(Link)`
  font-weight: 600;

  &:hover {
    color: ${PRIMARY};
    cursor: pointer;
  }
`;
